"use client";

import Button from "../../Button/button";
import DeliveryOption from "@/components/common/DeliveryOption";
import ImageWithFallback from "@/components/common/ImageWithFallback";

const RightSection = ({
  t,
  info,
  imageTypes,
  showBranchModal,
  addProductToBasket,
}) => {
  const brandTier = info?.brand?.brand_tier;
  return (
    <div className="plpRightPart">
      <div className="lg:flex hidden justify-between items-start brand">
        {info.brand?.title && (
          <div className="w-auto max-h-[40px] min-h-[40px] relative flex">
            <ImageWithFallback
              width={192}
              height={40}
              src={info.brand?.image}
              type={imageTypes.brand}
              alt={info.brand?.title || "brand"}
              key={`${info.brand?.title}_desktop`}
              className="object-contain object-left"
            />
          </div>
        )}
        {brandTier && (
          <span className={`radio-badge capitalize ${brandTier}`}>
            {brandTier}
          </span>
        )}
      </div>

      <DeliveryOption
        t={t}
        branch={info.branch}
        hasBranchStock={info?.stock_in_branch}
        muteClickCollect={info?.muteClickCollect}
        homeDeliveryStock={info?.homeDeliveryStock}
        showBranchModal={() => showBranchModal(info)}
      />

      <div className="flex lg:flex-col lg:items-start items-center justify-between flex-row">
        <div className="xs:flex hidden items-baseline">
          <p
            className={`xl:text-headline-3 xs:text-headline-4 text-body-text-1-b lg:mb-2 mb-0 flex ${
              info?.showStrikePrice ? "text-primary-red" : ""
            }`}
          >
            {info?.final_price}
          </p>
          {info?.showStrikePrice && (
            <span className="oldPrice ms-[6px]">{info?.regular_price}</span>
          )}
        </div>

        <Button
          icon="shopping"
          iconPosition="left"
          onClick={addProductToBasket}
          disabled={!info?.homeDeliveryStock && info?.muteClickCollect}
          className="xs:relative absolute xs:bottom-0 bottom-[68px] left-0 lg:!w-12/12 xs:!w-6/12 w-12/12"
          theme={`add-to-basket-btn ${
            !info?.homeDeliveryStock && info?.muteClickCollect && "grey-btn"
          }`}
        >
          {t("button.add_to_basket")}
        </Button>
      </div>
    </div>
  );
};

export default RightSection;
